"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maybeExpand = void 0;
const fileCollectionItemsUngzip_1 = require("../fileCollectionItemsUngzip");
const fileCollectionItemsUnzip_1 = require("../fileCollectionItemsUnzip");
/**
 * Utility function that allows to expand gzip and zip files without really expanding them
 * @param fileCollection
 * @param options
 * @returns
 */
async function maybeExpand(fileCollectionItems, options) {
    const { unzip = {}, ungzip = {} } = options;
    fileCollectionItems = await (0, fileCollectionItemsUnzip_1.fileCollectionItemsUnzip)(fileCollectionItems, unzip);
    fileCollectionItems = await (0, fileCollectionItemsUngzip_1.fileCollectionItemsUngzip)(fileCollectionItems, ungzip);
    return fileCollectionItems;
}
exports.maybeExpand = maybeExpand;
//# sourceMappingURL=maybeExpand.js.map